angular.module("vgresiduos").controller("OrganizationUnitPermissionGroupEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/perfil-acesso/${$stateParams.id}`);
		};
	}
]);
